<template>
  <!-- コンテンツ -->
  <div id="content">
    <div id="tab">
      <ul class="tabMenu">
        <li class="tab-item active">見積もり・構成明細</li>
      </ul>
    </div>

    <!-- タブのコンテンツ -->
    <div id="tabContents">
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <!-- 見積書 -->
      <div class="estimate preview_content">
        <ul class="btn_list">
          <li class="main_btn" @click="outputEstimate">
            <img :src="imgBom" alt="bom" width="14px" height="auto" /> 見積書出力
          </li>
          <li class="main_btn" @click="outputBom">
            <img :src="imgBom" alt="bom" width="14px" height="auto" /> 構成明細出力
          </li>
        </ul>
        <div class="estimate_option">
          <h3>見積オプション</h3>
          <table>
            <tr>
              <td>見積書作成日</td>
              <td>{{ estimateDate }}</td>
            </tr>
            <tr v-if="additionalCostItemName1">
              <td>{{ additionalCostItemName1 }}</td>
              <td>{{ additionalCostItemPrice1 }}</td>
            </tr>
            <tr v-if="additionalCostItemName2">
              <td>{{ additionalCostItemName2 }}</td>
              <td>{{ additionalCostItemPrice2 }}</td>
            </tr>
            <tr v-if="additionalCostItemName3">
              <td>{{ additionalCostItemName3 }}</td>
              <td>{{ additionalCostItemPrice3 }}</td>
            </tr>
            <tr v-if="additionalCostItemName4">
              <td>{{ additionalCostItemName4 }}</td>
              <td>{{ additionalCostItemPrice4 }}</td>
            </tr>
            <tr v-if="additionalCostItemName5">
              <td>{{ additionalCostItemName5 }}</td>
              <td>{{ additionalCostItemPrice5 }}</td>
            </tr>
            <tr v-if="additionalCostItemName6">
              <td>{{ additionalCostItemName6 }}</td>
              <td>{{ additionalCostItemPrice6 }}</td>
            </tr>
            <tr v-if="additionalCostItemName7">
              <td>{{ additionalCostItemName7 }}</td>
              <td>{{ additionalCostItemPrice7 }}</td>
            </tr>
            <tr v-if="additionalCostItemName8">
              <td>{{ additionalCostItemName8 }}</td>
              <td>{{ additionalCostItemPrice8 }}</td>
            </tr>
            <tr v-if="discountItemName1">
              <td>{{ discountItemName1 }}</td>
              <td>{{ discountItemPrice1 }}</td>
            </tr>
            <tr v-if="discountItemName2">
              <td>{{ discountItemName2 }}</td>
              <td>{{ discountItemPrice2 }}</td>
            </tr>
            <tr v-if="discountItemName3">
              <td>{{ discountItemName3 }}</td>
              <td>{{ discountItemPrice3 }}</td>
            </tr>
          </table>
        </div>
        <div class="total_price">
          <h3>合計金額</h3>
          <table>
            <tr>
              <th>原価合計金額</th>
              <th>定価基準合計</th>
              <th>別売品費合計</th>
            </tr>
            <tr>
              <td>{{ allRetailTotal }}</td>
              <td>{{ allPropertyRetailTotal }}</td>
              <td>{{ allEstItemCost }}</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import { API_URL } from '../constants/App'
import Modal from '../components/common/Modal'
import LoadingModal from '../components/common/LoadingModal'

export default {
  name: 'Preview',
  components: {
    'dd-modal': Modal,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      /** タブコンテンツ判定 */
      isActive: 0,
      /** 物件id */
      propertyId: null,
      /** 見積もり情報 */
      estimateDate: null,
      additionalCostItemName1: null,
      additionalCostItemPrice1: null,
      additionalCostItemName2: null,
      additionalCostItemPrice2: null,
      additionalCostItemName3: null,
      additionalCostItemPrice3: null,
      additionalCostItemName4: null,
      additionalCostItemPrice4: null,
      additionalCostItemName5: null,
      additionalCostItemPrice5: null,
      additionalCostItemName6: null,
      additionalCostItemPrice6: null,
      additionalCostItemName7: null,
      additionalCostItemPrice7: null,
      additionalCostItemName8: null,
      additionalCostItemPrice8: null,
      discountItemName1: null,
      discountItemPrice1: null,
      discountItemName2: null,
      discountItemPrice2: null,
      discountItemName3: null,
      discountItemPrice3: null,
      allRetailTotal: null,
      allPropertyRetailTotal: null,
      allEstItemCost: null,
      /** 構成明細情報 */
      bomHeaderBase: {},
      bomBaseList: {},
      bomHeaderProperty: {},
      bomPropertyList: {},
      bomHeaderClient: {},
      bomClientList: {},
      bomHeaderEstimate: {},
      bomEstimateList: {},
      bomHeaderRoom: {},
      bomRoomList: {},
      bomHeaderPrice: {},
      bomPriceList: {},
      bomHeaderSpace: {},
      bomSpaceList: {},
      // テーブルの行数
      tableRawNum: 0,
      imgBom: this.getImage('print/ic_output.svg')
    }
  },
  methods: {
    getBom: function () {
      this.propertyId = this.$route.query.propertyId
      let urlStr = API_URL.PREVIEW + '/' + this.propertyId
      this.$refs.loadingModalRef.showModal(true)
      axios
        .get(urlStr)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          console.log('▼▼▼▼ DEBUG:GET BOM DATA ▼▼▼▼')
          console.log(response)
          console.log('▲▲▲▲ DEBUG:GET BOM DATA ▲▲▲▲')
          // レスポンス取得
          let csvDataMap = response.data.data
          // BOMの設定
          let baseDataList = csvDataMap.BASE_INFO
          this.bomHeaderBase = baseDataList[0]
          this.bomBaseList = baseDataList[1]
          let propertyDataList = csvDataMap.PROPERTY_INFO
          this.bomHeaderProperty = propertyDataList[0]
          this.bomPropertyList = propertyDataList[1]
          let clientDataList = csvDataMap.CLIENT_INFO
          this.bomHeaderClient = clientDataList[0]
          this.bomClientList = clientDataList[1]
          let estimateDataList = csvDataMap.ESTIMATE_INFO
          this.bomHeaderEstimate = estimateDataList[0]
          this.bomEstimateList = estimateDataList[1]
          let roomDataList = csvDataMap.ROOM_INFO
          this.bomHeaderRoom = roomDataList[0]
          this.bomRoomList = roomDataList.slice(1, roomDataList.length)
          let priceDataList = csvDataMap.PRICE_INFO
          this.bomHeaderPrice = priceDataList[0]
          this.bomPriceList = priceDataList.slice(1, priceDataList.length)
          let spaceDataList = csvDataMap.PLAN_INFO
          this.bomHeaderSpace = spaceDataList[0]
          this.bomSpaceList = spaceDataList.slice(1, spaceDataList.length)

          // テーブルの行数取得
          this.tableRawNum = Math.max(
            this.bomHeaderBase.length,
            this.bomHeaderProperty.length,
            this.bomHeaderClient.length,
            this.bomHeaderEstimate.length,
            this.bomHeaderRoom.length,
            this.bomHeaderPrice.length,
            this.bomHeaderSpace.length
          )
          this.setEstimateData()
        })
        .catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    outputBom: function () {
      let payload = {
        propertyId: this.propertyId
      }
      let urlStr = API_URL.OUTPUT + '/bom'
      console.log('▼▼▼▼　DEBUG:OUTPUT BOM ▼▼▼▼')
      console.log(payload)
      console.log('▲▲▲▲　DEBUG:OUTPUT BOM ▲▲▲▲')
      this.$refs.loadingModalRef.showModal(true)
      axios
        .post(urlStr, payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error'
            })
          } else {
            App.showModal({
              messages: ['※出力物はメールで送られます。']
            })
          }
        })
        .catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    outputEstimate: function () {
      let payload = {
        propertyId: this.propertyId
      }
      let user = App.getUserInfo()
      let eststr = '/estimate'
      if (user.copId === 170) {
        eststr = '/estimate_order'
      }
      let urlStr = API_URL.OUTPUT + eststr
      console.log('▼▼▼▼　DEBUG:OUTPUT ESTIMATE ▼▼▼▼')
      console.log(payload)
      console.log('▲▲▲▲　DEBUG:OUTPUT ESTIMATE ▲▲▲▲')
      this.$refs.loadingModalRef.showModal(true)
      axios
        .post(urlStr, payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error'
            })
          } else {
            App.showModal({
              messages: ['※出力物はメールで送られます。']
            })
          }
        })
        .catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    setEstimateData: function () {
      this.estimateDate = this.bomEstimateList[7]
      this.additionalCostItemName1 = this.bomEstimateList[14]
      this.additionalCostItemPrice1 = this.bomEstimateList[15]
      this.additionalCostItemName2 = this.bomEstimateList[16]
      this.additionalCostItemPrice2 = this.bomEstimateList[17]
      this.additionalCostItemName3 = this.bomEstimateList[18]
      this.additionalCostItemPrice3 = this.bomEstimateList[19]
      this.additionalCostItemName4 = this.bomEstimateList[20]
      this.additionalCostItemPrice4 = this.bomEstimateList[21]
      this.additionalCostItemName5 = this.bomEstimateList[22]
      this.additionalCostItemPrice5 = this.bomEstimateList[23]
      this.additionalCostItemName6 = this.bomEstimateList[24]
      this.additionalCostItemPrice6 = this.bomEstimateList[25]
      this.additionalCostItemName7 = this.bomEstimateList[26]
      this.additionalCostItemPrice7 = this.bomEstimateList[27]
      this.additionalCostItemName8 = this.bomEstimateList[28]
      this.additionalCostItemPrice8 = this.bomEstimateList[29]
      this.discountItemName1 = this.bomEstimateList[8]
      this.discountItemPrice1 = this.bomEstimateList[9]
      this.discountItemName2 = this.bomEstimateList[10]
      this.discountItemPrice2 = this.bomEstimateList[11]
      this.discountItemName3 = this.bomEstimateList[12]
      this.discountItemPrice3 = this.bomEstimateList[13]
      this.allRetailTotal = this.bomEstimateList[35]
      this.allPropertyRetailTotal = this.bomEstimateList[36]
      this.allEstItemCost = this.bomEstimateList[37]
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  mounted: function () {
    this.getBom()
  }
}
</script>

<style lang="scss" scoped>
#content {
  min-width: 1123px;
  min-height: 500px;
  margin: 15px;
  display: inline-block;
}
.tabMenu {
  display: flex;
  // background-color: #fff;
  li {
    width: auto;
    padding: 10px 20px 10px 9px;
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
    background-color: #ddd;
    cursor: pointer;
    font-weight: 600;
    border-top: 4px solid #ddd;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    &.active {
      background-color: #fff;
      border-top: 4px solid #ff4500;
    }
    input {
      margin: 0 0 1px 0;
    }
  }
}
#tabContents {
  border: 1px solid #fff;
  background-color: #fff;
  width: auto;
  height: auto;
  padding: 12px;
  border-radius: 0 5px 5px 5px;
  box-sizing: border-box;
  box-shadow: 0 0 10px hsla(0, 0%, 40%, 0.1);
}
.preview_content {
  margin: 20px;
  display: inline-block;
  min-width: 90%;
  height: auto;
}
.bom-list {
  margin-top: 10px;
}
table {
  width: auto;
  td {
    white-space: nowrap;
    border: 1px solid #ddd;
    line-height: 20px;
    width: 100px;
  }
}
.estimate_option {
  margin: 30px;
}
.total_price {
  margin: 30px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/PropertyPreview.vue